<template>
  <div
    class="mb-3 flex items-start gap-2 rounded-md border border-warning-200 bg-warning-50 px-3 py-2.5 text-sm/snug"
    role="status"
  >
    <AppIcon
      name="i-heroicons-exclamation-triangle-20-solid"
      class="mt-0.5 size-5 shrink-0 text-warning-600"
      aria-hidden="true"
    />
    <div class="flex flex-col gap-0.5 font-mainFont">
      <p v-if="title" class="font-medium text-neutral-900">{{ title }}</p>
      <p class="text-neutral-700">{{ description }}</p>
    </div>
  </div>
</template>

<script setup>
import AppIcon from '../../AppIcon.vue'

defineProps({
  title: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    required: true,
  },
})
</script>
